import React from 'react';

/**
 * Riga con titolo + descrizione a sinistra e switch a destra (mockup: `.switch-row`
 * + `.switch`, viste 2 e 4). Usata dalla sezione Calendario per lo switch di sync e per
 * "Mostra descrizione nell'evento Google Calendar".
 */
export interface SwitchRowProps {
  id?: string;
  title: string;
  description?: string;
  checked: boolean;
  onChange(value: boolean): void;
  dataTour?: string;
  /** Il "?" accanto al titolo. */
  help?: React.ReactNode;
}

export function SwitchRow({ id, title, description, checked, onChange, dataTour, help }: SwitchRowProps): JSX.Element {
  return (
    <div className="flex items-start justify-between gap-2.5 px-1.5" data-tour={dataTour}>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
        <label
          htmlFor={id}
          className="block text-xs font-medium text-[#37352F] dark:text-white cursor-pointer"
          onClick={(e) => {
            // Senza `id` non c'è associazione nativa label→switch: replichiamo il click.
            if (!id) {
              e.preventDefault();
              onChange(!checked);
            }
          }}
        >
          {title}
        </label>
        {help}
        </div>
        {description && <p className="mt-0.5 text-[11px] text-[#787774] dark:text-gray-400">{description}</p>}
      </div>
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        aria-label={title}
        onClick={() => onChange(!checked)}
        className={`relative mt-0.5 h-[19px] w-[34px] shrink-0 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#2383E2]/40 ${
          checked ? 'bg-[#2383E2]' : 'bg-[rgba(55,53,47,0.16)] dark:bg-[#4A5053]'
        }`}
      >
        <span
          aria-hidden="true"
          className={`absolute top-[2px] h-[15px] w-[15px] rounded-full bg-white transition-all ${
            checked ? 'left-[17px]' : 'left-[2px]'
          }`}
        />
      </button>
    </div>
  );
}
